export interface BlogPost {
  id: number;
  image: string;
  date: string;
  month: string;
  author: string;
  comments: number;
  title: string;
  description?: string;
}


export const eventData: BlogPost[] = [
  
  {
    id: 2,
    image: "/images/events/image12.jpg",
    date: "8",
    month: "Oct",
    author: "Knowledge Trip",
    comments: 5,
    title:
      "Ashva Education’s Knowledge Trip inspires students through exploration, discovery, and practical learning.",
  },
  {
    id: 4,
    image: "/images/events/image13.jpg",
    date: "29",
    month: "Mar",
    author: "Sports Day",
    comments: 5,
    title:
      "Ashva Education’s Sports Day unites students and staff in friendly competition, teamwork, and the spirit of excellence.",
  },
  {
    id: 8,
    image: "/images/events/image8.jpg",
    date: "15",
    month: "Aug",
    author: "Independence Day",
    comments: 5,
    title:
      "Ashva Education celebrated Independence Day with pride, unity, and patriotic performances honoring our nation’s spirit.",
  },
  {
    id: 5,
    image: "/images/events/image5.png",
    date: "1",
    month: "Aug",
    author: "Welcome Ceremony",
    comments: 5,
    title:
      "The Fresher’s Day at Ashva Education celebrated new beginnings, creativity, and friendship among the 2025–2026 batch.",
  },
  {
    id: 3,
    image: "/images/events/image3.png",
    date: "4",
    month: "Dec",
    author: "Health Campaign",
    comments: 5,
    title:
      "Health Campaigns promote wellness and awareness among students and staff, fostering a healthy and active campus community.",
  },
  {
    id: 6,
    image: "/images/events/image6.png",
    date: "29",
    month: "May",
    author: "Awards",
    comments: 5,
    title:
      "Ashva Education proudly celebrated the National Icon Awards, honoring excellence, inspiration, and outstanding achievements.",
  },
  {
    id: 1,
    image: "/images/events/image1.png",
    date: "10",
    month: "Apr",
    author: "Annual Day",
    comments: 5,
    title:
      "Our Annual Day at Ashva Education highlights student talent and success, celebrating creativity and academic excellence.",
  },
  {
    id: 17,
    image: "/images/events/image14.jpg",
    date: "6",
    month: "Feb",
    author: "Traditional Day",
    comments: 5,
    title:
      "We celebrate Traditional Day with pride, showcasing our rich culture, unity, and respect for heritage through vibrant activities.",
  },
  {
    id: 9,
    image: "/images/events/image11.jpg",
    date: "9",
    month: "Nov",
    author: "Science Exhibition",
    comments: 5,
    title:
      "Ashva Education celebrated the Science Exhibition with pride, creativity, and inspiring innovations showcasing brilliance.",
  },
];



export const blogPostsDataTwo = [
    {
        image: "/images/events/image10.png",
        date: "21 march 2024",
        title: "Science Exhibitions",
        description:
            "Students showcase their creativity and innovative projects, highlighting the importance of science in everyday life",
    },
    {
        image: "/images/events/image8.jpg",
        date: "21 march 2024",
        title: "Campaigns",

        description:
            "Our college organizes awareness campaigns to inspire social responsibility and community involvement.",
    },
    {
        image: "/images/events/image6.png",
        date: "21 march 2024",
        title: "Functions",

        description:
            "Cultural and academic functions bring together students and faculty to celebrate achievements and traditions.",
    },
]

export const blogPostsDataThree = [
    {
        image: "/images/blogs/blog13.jpg",
        categories: ["Education", "Language", "Arabic"],
        readTime: "3 Minutes Read",
        title: "The Power of Consistency: How Regular Practice Boosts Language Proficiency",
    },
    {
        image: "/images/blogs/blog14.jpg",
        categories: ["Education", "Language", "Arabic"],
        readTime: "3 Minutes Read",
        title: "Strategies for Overcoming Common Challenges in Multilingual Communication",
    },
]